import { Dimensions } from 'react-native';

/**
 * Calculates a dynamic page size (number of rows) for the data table.
 *
 * Backward compatible signature: calculateDynamicPageSize(hasExtraFooter?: boolean)
 * New signature: calculateDynamicPageSize(options?: {
 *   heights?: {
 *     header?: number;
 *     tableHeader?: number;
 *     pagination?: number;
 *     functionBar?: number;
 *     paddingVertical?: number;
 *     extraFooter?: number;
 *     row?: number
 *   };
 *   hasExtraFooter?: boolean;
 *   screenHeight?: number;
 *   minRows?: number;
 *   maxRows?: number;
 * })
 */
const calculateDynamicPageSize = (optionsOrHasExtraFooter = false) => {
  const isBoolean = typeof optionsOrHasExtraFooter === 'boolean';
  const opts = isBoolean ? {} : optionsOrHasExtraFooter || {};
  const hasExtraFooter = isBoolean ? optionsOrHasExtraFooter : !!opts.hasExtraFooter;

  const screenHeight = opts.screenHeight || Dimensions.get('window').height;

  const heights = opts.heights || {};
  const rowHeightPx = typeof heights.row === 'number' ? heights.row : 48;
  const minRows = typeof opts.minRows === 'number' ? opts.minRows : 3;
  const maxRows = typeof opts.maxRows === 'number' ? opts.maxRows : 50;

  const headerHeight = typeof heights.header === 'number' ? heights.header : 100;
  const tableHeaderHeight = typeof heights.tableHeader === 'number' ? heights.tableHeader : 35;
  const paginationHeight = typeof heights.pagination === 'number' ? heights.pagination : 80;
  const functionBarHeight = typeof heights.functionBar === 'number' ? heights.functionBar : 65;
  const paddingVertical = typeof heights.paddingVertical === 'number' ? heights.paddingVertical : 50;
  const extraFooterHeight = typeof heights.extraFooter === 'number' ? heights.extraFooter : 0;

  const reservedHeight = headerHeight
    + tableHeaderHeight
    + paginationHeight
    + functionBarHeight
    + paddingVertical
    + (hasExtraFooter ? extraFooterHeight : 0);

  const availableHeight = Math.max(0, screenHeight - reservedHeight);
  const computedRows = Math.floor(availableHeight / rowHeightPx);
  return Math.max(minRows, Math.min(maxRows, computedRows));
};

export default calculateDynamicPageSize;
